import { LoadingBlockSizeType } from './types';

export const getSizeByType: Record<LoadingBlockSizeType, number> = {
  small: 24,
  default: 40,
  large: 70,
};
